import 'bootstrap/js/tooltip';
import 'bootstrap/js/popover';

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Highcharts from 'highcharts/highcharts';

import ChartDataCollection from 'collections/chart_data';
import ChartPoint from 'models/chart_point';
import DateNav from 'core/controllers/date_navigation';


// Local Utility Functions
var get_latest_unique_items = function (collection) {
  // Given a collection of items which have a 'date' property,
  // filter out items with duplicate dates, keeping only the latest
  // item for each 'date'
  //
  // Collection should already be ordered so that if there are multiple
  // items on a specific date, then the one we want should be first.
  // In our case, Django does this by ordering: date DESC, id DESC
  //
  // Returns an array of the resulting items

  // Create a dictionary where each key is one of the unique dates
  // and its value is the set of items with that date.
  var grouped_by_date = collection.groupBy(function (item) { return item.get('date'); });
  // Go through the dates in order and for each one, pick out the item with
  // the highest ID by sorting that set of items by ID and taking the last one.
  var dates = _.keys(grouped_by_date).sort();
  return _.map(dates, function (date) {
    return _.last(_.sortBy(grouped_by_date[date], function (item) { return Number(item.get('id')); }));
  });
};

export default Backbone.View.extend({
  events: {
    'click #historiAverage': 'showhide_average',
    'click #historiAverageCheck': 'showhide_average_checkMark'
  },

  // initialize takes a chartType: 'week' or 'month'
  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    var self = this;

    this.setElement($('#charts'));
    this.$moodChart = $('#mood-chart', this.$el);
    this.$activityChart = $('#activity-chart', this.$el);
    this.$axis = $('ul#charts-axis', this.$el);
    this.gauges = {};

    this.chartType = options.chartType;
    this.enable_rendering = true;
    this.reset_gauges();
    this.date_nav = options.chart_date_nav || new DateNav({
      pagination: $('.date-pagination', this.el),
      pager: $('.pager', this.el)
    });

    this._isHistoricShown = true;

    // Page elements
    this.charts = $(this.$moodChart).add(this.$activityChart);
    this.$stats = $('#chart-stats');
    this.daysReported = $('#days-reported span', this.$stats);
    this.yourPeakMood = $('#your-peak-mood span', this.$stats);
    this.averageMoodScore = $('#average-mood-score span', this.$stats);
    this.activitiesReported = $('#activities-reported span', this.$stats);
    this.averageActivities = $('#average-activities span', this.$stats);
    this.on_tracker_page = $('body.daily-tracker').length !== 0;

    // Templates
    this.chart_point_template = _.template($('#column-chart-point').html());
    this.axis_templates = {
      week: _.template($('#week-axis-template').html()),
      month: _.template($('#month-axis-template').html())
    };
    this.tooltip_template = _.template($('#tooltip').html());

    this.activityCollection = options.parentView.activity_collection;
    this.activityLogCollection = options.parentView.activity_log_collection;
    this.moodBoosterCollection = options.parentView.moodBooster_collection;
    this.moodCollection = options.parentView.mood_collection;
    this.journalCollection = options.parentView.journal_collection;
    // store all the data needed for charting in a backbone collection
    this.chart_data = new ChartDataCollection();

    // need 'today' to accurately show future days on graph/chart
    this.today = DateNav.just_the_date(new Date());
    this.date_nav.on('change', this.date_changed);
    if (options.parentView.date_nav) {
      options.parentView.date_nav.on('change', function (new_date, previous_date) {
        if (previous_date < this.date_nav.start_date() ||
                          previous_date > this.date_nav.end_date()) {
          this.date_changed();
          this.date_nav.render();
        }
      }, this);
    }

    // store start_date and end_date locally
    this.date_nav.set_navigate_by(this.chartType);
    this.date_nav.render();
    // if 'week', need to change_date so start_date/end_date
    // are set properly
    this.update_dates();

    // If somebody resizes the weekly page, we might need to resize and render our charts again.
    // Wait until a half second after they finish, then update. (The other pages don't change chart size.)
    if (this.chartType === 'week') {
      $(window).resize(this.chart_resize);

      $(window).bind('chartResizeEnd', function () {
        self.create_charts();
        self.update();
      });
    }

    this.show_loading();
    this.create_charts();
  },

  chart_resize: function () {
    if (this.chartResizeTO) {
      clearTimeout(this.chartResizeTO);
    }
    this.chartResizeTO = setTimeout(function () {
      $(this).trigger('chartResizeEnd');
    }, 500);
  },

  date_changed: function () {
    this.show_loading();
    this.create_charts();
    this.update();
  },

  dailyTrackerDate: function (ev) {
    ev.preventDefault();
    var link = $(ev.currentTarget);
    var date = link.data('date');
    var trackerUrl = window.Urls['tracker.daily_tracker']();
    window.location = `${trackerUrl}?date=${date}`;
  },

  reset_gauges: function () {
    this.gauges = {
      daysReported: 0,
      yourPeakMood: 0,
      averageMoodScore: 0,
      activitiesReported: 0,
      averageActivities: 0,
    };
  },

  show_loading: function () {
    /* global icon_loading_animation */
    this.charts.html('').css('background-image', 'url(' + icon_loading_animation + ')');
    this.charts.css('background-repeat', 'no-repeat');
    this.charts.css('background-position', 'center center');
  },

  switchChartType: function (chartType) {
    this.chartType = chartType;
    this.date_nav.set_navigate_by(this.chartType);
    this.date_nav.render();
    this.update();
  },

  update_dates: function () {
    this.start_date = this.date_nav.start_date();
    this.end_date = this.date_nav.end_date();
  },

  update: function () {
    this.update_dates();
    this.calc_chart_data();
    this.render();
    this.trigger('updated');
  },

  render: function () {
    if (this.enable_rendering) {
      this.render_graph();
      this.render_axis();
    }
    return this;
  },

  resize_charts: function () {
    var chartWidth, chartHeight;
    if (this.chartType === 'weekly') {
      if ($(window).width() < 142) {
        chartWidth = $(window).width() - 10;
        chartHeight = 175;
      } else {
        chartWidth = 542;
        chartHeight = 300;
      }
    } else if (this.chartType === 'monthly') {
      chartWidth = 900;
      chartHeight = 100;
    }
    this.charts.height(chartHeight);
    return { width: chartWidth, height: chartHeight };
  },

  create_charts: function () {
    try {
      if (this.mood_chart !== undefined) {
        this.mood_chart.destroy();
      }
    } catch (err) { /* Don't worry about it */ }
    try {
      if (this.activity_chart !== undefined) {
        this.activity_chart.destroy();
      }
    } catch (err) { /* Don't worry about it */ }

    var size = this.resize_charts();
    var self = this;
    var chart_options = {
      chart: {
        backgroundColor: 'none',
        renderTo: this.$moodChart[0],
        margin: [ 0, 0, 0, 0 ],
        width: size.width,
        height: size.height,
        borderWidth: 1,
        borderColor: '#ffc400',
        borderRadius: 9,
        shadow: false,
        reflow: false,
        type: 'column',
        style: {
          fontFamily: "'proxima-nova', Helvetica, Arial, sans-serif",
          color: '#333333',
        },
        events: {
          redraw: function (e) {
            _.each(e.target.series[0].points, function (point) {
              var element = $(point.graphic.element);
              element.attr('height', element.attr('height') + 6);
              if (point.y === 0) {
                element.attr('y', element.attr('y') + 3);
              }
            });
          }
        }
      },
      title: {
        text: this.on_tracker_page ? '' : 'Mood',
        align: 'left',
        x: 0,
        y: 15,
        style: {
          fontFamily: "'proxima-nova', Helvetica, Arial, sans-serif",
          fontSize: '18px',
          color: '#333333',
        },
      },
      subtitle: { text: '' },
      legend: {
        enabled: false,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        x: 0,
        y: 0,
        borderWidth: 0,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            color: '#ffffff',
            formatter: this.chart_point_template,
            crop: false,
            inside: true,
            useHTML: true,
            verticalAlign: 'top',
            style: {
              fontFamily: "'proxima-nova', Helvetica, Arial, sans-serif",
              fontSize: '14px',
            },
          }
        },
        series: {
          spacingTop: 10,
          shadow: false,
          borderRadius: 6,
          borderWidth: 4,
          point: {
            events: {
              // TODO: Get this popover stuff in a view
              mouseOver: function (e) {
                var column = $(this.graphic.element);
                column.data('column-hover', true);
                var popover = column.data('popover');
                // Get the chart position
                var chart = this.series.name === 'Mood' ?
                  $('#mood-chart') : $('#activity-chart');
                var chartPosition = chart.position();
                var chartPosX = chartPosition.left;
                var extraPos = $('#charts').position();
                if ($('#extra-tracking').length) {
                  extraPos = $('#extra-tracking').position();
                }

                if (typeof popover === 'undefined') {
                  column.data('hide-timeout', false);
                  // Prepare an element to help position the tooltip
                  var x = extraPos.left +
                    chartPosition.left +
                    Math.round(this.plotX);
                  var y = extraPos.top +
                    chartPosition.top +
                    Math.max(50, Math.round(this.plotY)) +
                    20;

                  popover = $('<div style="height: 0px; width: 0px; overflow: show; position: absolute; left: ' + x + 'px; top: ' + y + 'px;"></div>');
                  $('body').append(popover);
                  column.data('popover', popover);
                }

                // Prepare the tooltip itself
                popover.popover({
                  placement: 'top',
                  html: true,
                  content: self.tooltip_template(_.extend(e.target, { DateNav: DateNav }))
                });
                popover.data('popover-hover', false);
                popover.popover('show');

                // Make sure popover stays visible when
                // hovering over it
                var popover_el = popover.next();

                // Enable star tooltips
                $('.mood-booster.starred', popover_el).tooltip();

                // align pop up so it doesn't go out of the view
                if (popover_el.offset().top < 20) {
                  popover_el.css('top', '20px');
                }
                if ($(window).width() < popover_el.offset().left + popover_el.width()) {
                  var diff = popover_el.offset().left + popover_el.width() - $(window).width() + 20;// add little padding
                  popover_el.css('left', popover_el.offset().left - diff + 'px');
                }


                // Now repositon the arrow
                var arroPosDiff = extraPos.left + this.plotX + chartPosX - popover_el.offset().left - popover_el.width() / 2;
                var offSetArrow = popover_el.width() / 2 + arroPosDiff;
                $('.arrow', popover_el).css('left', offSetArrow + 'px');


                popover_el.mouseenter({ popover: popover }, function (e) {
                  e.data.popover.data('popover-hover', true);
                });
                popover_el.find('.daily-tracker').on('click', self.dailyTrackerDate);
                popover_el.mouseleave({ popover: popover }, function (e) {
                  e.data.popover.data('popover-hover', false);
                  e.data.popover.popover('hide');
                });
              },
              mouseOut: function (e) {
                var column = $(this.graphic.element);
                column.data('column-hover', false);
                if (!column.data('hide-timeout')) {
                  var popover = column.data('popover');
                  column.data('hide-timeout', true);
                  setTimeout(function () {
                    // Hide the popover if we are no longer
                    // hovering over the popover or the
                    // chart column.
                    column.data('hide-timeout', false);
                    if (!popover.data('popover-hover') &&
                                                  !column.data('column-hover')) {
                      popover.popover('destroy');
                    }
                  }, 100);
                }
              }
            }
          }
        }
      },
      xAxis: {
        title: { text: '' },
        tickInterval: 1,
        tickColor: '#f7f7f7',
        gridLineColor: '#ffc321',
        gridLineWidth: 1,
        labels: { enabled: false }
      },
      yAxis: {
        title: { text: '' },
        endOnTick: false,
        startOnTick: false,
        min: 0,
        max: this.on_tracker_page ? 10 : 12,
        tickInterval: 2,
        tickColor: '#f7f7f7',
        gridLineColor: '#ffc321',
        labels: { enabled: false },
        tickPositioner: function (min, max) {
          var result = [];
          var interval = this.options.tickInterval;
          for (var i = min + interval; i < max; i = i + interval) {
            result.push(i);
          }
          return result;
        }
      },
      series: [{
        name: 'Mood',
        color: '#ffc321',
        borderColor: null
      }],
      tooltip: {
        enabled: false
      },
      credits: {
        enabled: false
      }
    };
    this.mood_chart = new Highcharts.Chart(chart_options);
    if (this.$activityChart.length) {
      // Adjust options for activity chart
      chart_options.chart.renderTo = this.$activityChart[0];
      chart_options.chart.borderColor = '#72cede';
      chart_options.title.text = 'Activities';
      chart_options.series = [{
        name: 'Activities',
        color: '#6bcadb',
        borderColor: '#6bcadb'
      }];
      chart_options.xAxis.gridLineColor = '#6bcadb';
      chart_options.yAxis.gridLineColor = '#6bcadb';
      chart_options.yAxis.tickPixelInterval = 100;


      this.activity_chart = new Highcharts.Chart(chart_options);
    }
  },

  addAverage: function (chart, avg, id) {

    if (!avg) { return; }
    if ($('#' + id + '-average-line').length > 0) { return; }
    var w = chart.renderer.width - 1;
    var h = chart.renderer.height;
    var ypos = h - h / 10 * avg;

    var group = chart.renderer.g().add();
    var path = chart.renderer.path([ 'M', 0, ypos, 'L', w, ypos ])
      .attr({
        'id': id + '-average-line',
        'stroke-width': 3,
        'stroke': '#1ca0da',
        'dashstyle': 'dash'
      }).add(group);

    if (this._isHistoricShown === false) {
      this.hide_average(true);
    }
  },

  hide_average: function (hideit) {

    if (hideit === true) {
      $('#mood-average-line').hide();
      $('#activity-average-line').hide();
      this._isHistoricShown = false;
    } else {
      $('#mood-average-line').show();
      $('#activity-average-line').show();
      this._isHistoricShown = true;
    }


  },


  render_graph: function () {
    this.resize_charts();

    if (typeof this.mood_chart.series[0] !== 'undefined') {
      this.mood_chart.series[0].dates = this.chart_data.pluck('date');
      this.mood_chart.series[0].journals = this.chart_data.pluck('journal');
      this.mood_chart.series[0].setData(this.chart_data.pluck('mood'));
    }
    if (this.$activityChart.length && typeof this.activity_chart.series !== 'undefined') {
      this.activity_chart.series[0].dates = this.chart_data.pluck('date');
      this.activity_chart.series[0].journals = this.chart_data.pluck('journal');
      this.activity_chart.series[0].setData(this.chart_data.pluck('activities'));
    }

    this.charts.find('a.daily-tracker').on('click', this.dailyTrackerDate);

    // Update gauge elements
    this.daysReported.html(this.gauges.daysReported);
    this.yourPeakMood.html(this.gauges.yourPeakMood);
    if (this.gauges.averageMoodScore === 'N/A') {
      this.averageMoodScore.addClass('small').html(this.gauges.averageMoodScore);
    } else {
      this.averageMoodScore.removeClass('small').html(this.gauges.averageMoodScore);
    }
    this.activitiesReported.html(this.gauges.activitiesReported);
    this.averageActivities.html(this.gauges.averageActivities);

    this.charts.css('background-image', 'none');

    if (typeof this.mood_chart.renderer !== 'undefined') {
      this.addAverage(this.mood_chart, this.moodCollection.average(), 'mood');
    }
    if (this.$activityChart.length) {
      this.addAverage(this.activity_chart, this.activityLogCollection.average(), 'activity');
    }
  },

  render_axis: function () {
    var ctx = {
      chart_data: this.chart_data.toJSON(),
      DateNav: DateNav
    };
    this.$axis.html(this.axis_templates[this.chartType](ctx));
    this.$axis.find('li').on('click', this.dailyTrackerDate);
  },

  calc_chart_data: function () {
    var self = this;
    this.chart_data.reset();

    // Clean moods - same story
    var unique_moods = get_latest_unique_items(this.moodCollection);
    // Turn it back into a collection
    this.moodCollection.reset(unique_moods);

    // Build chart data
    var date, activities, mood_updated, mood, d,
      mood_total = 0,
      mood_days = 0;
    this.reset_gauges();
    for (d = new Date(this.start_date); d <= this.end_date; d.setDate(d.getDate() + 1)) {
      var point = new ChartPoint();
      date = this.date_nav.formatted_date(d);
      var a = this.activityLogCollection.where({ date: date });
      var m = this.moodCollection.where({ date: date });
      var j = this.journalCollection.findWhere({ date: date });

      var future = d.getTime() > this.today;

      activities = future ? 0 : a.length;

      if (m.length) {
        mood = m[0].get('mood');
        mood_days++;
      } else {
        mood = 0;
      }

      // Update gauge numbers
      this.gauges.daysReported += mood || activities ? 1 : 0;
      if (mood > this.gauges.yourPeakMood) {
        this.gauges.yourPeakMood = mood;
      }
      mood_total = mood_total + mood;
      this.gauges.activitiesReported += activities;

      point.set({
        date: date,
        // Trick to make the column stop at the top of the graph,
        // but still inform us that it is out of range.
        activities: activities > 10 ? 10.01 : activities,
        mood: mood,
        journal: future || !j ? null : j.escape('journal')
      });
      this.chart_data.add(point);
    }
    // Gauge averages
    var total_days = this.date_nav.non_future_days_in_range();
    var avg_mood = Math.round(mood_total / mood_days);
    this.gauges.averageMoodScore = mood_days === 0 ? 'N/A' : avg_mood;
    this.gauges.averageActivities = Math.round(
      this.gauges.activitiesReported / total_days);
  },

  showhide_average: function () {
    var checkMark = $('#historiAverageCheck.check');
    if (checkMark.hasClass('setting-enabled') === true) {
      checkMark.removeClass('setting-enabled');
      this.hide_average(true);
    } else {
      checkMark.addClass('setting-enabled');
      this.hide_average();
    }
  },

  showhide_average_checkMark: function () {
    this.hide_average(this._isHistoricShown);
  }

});



// WEBPACK FOOTER //
// ./static/js/views/charts.js